import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

import AdminPage from "../pages/AdminPage";

const meApiUrl = `${process.env.REACT_APP_BACKEND_URL}/api/auth/me`;

export default function ProtectedAdmin() {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);

  useEffect(() => {
    const verifyAdmin = async () => {
      try {
        const response = await axios.get(meApiUrl, { withCredentials: true });
        if (!["owner", "admin"].includes(response.data.role)) {
          navigate("/dashboard", { replace: true });
          return;
        }
        setUser(response.data);
      } catch (error) {
        navigate("/login", { replace: true });
      }
    };
    verifyAdmin();
  }, [navigate]);

  const logout = async () => {
    await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}/api/auth/logout`,
      {},
      { withCredentials: true },
    );
    navigate("/login", { replace: true });
  };

  if (!user) {
    return <main className="auth-check" data-testid="admin-auth-check-state" />;
  }
  return <AdminPage user={user} onLogout={logout} />;
}